export const processParameters = (ReportID, formData, format = 'report') => {
  switch (ReportID) {
    case '314':
      return processCadDataByMonth(formData, format);
    default:
      return {};
  }
};
const processCadDataByMonth = (formData, format) => {
  if (!formData) return {};
  const newForm = {
    year: formData.year?.Code ?? new Date().getFullYear(),
    AgencyID: formData.agency.Code,
  };
  return newForm;
};

export const reportNameMapper = (id) => {
  switch (id) {
    case '314':
      return 'Cad Data By Month Report';
    default:
      return 'Report';
  }
};
